module.exports = __webpack_public_path__ + "images/emoji/one.1d474fa2cdbe7376c618.png";